import ReactController from '~/controllers/react_controller'
import AWSDashboardCharts from '~/dashboard/aws_dashboard_charts'

export default class AWSDashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
    hasCostCategories: Boolean,
  }

  createComponent() {
    return (
      <AWSDashboardCharts organizationId={this.organizationIdValue} hasCostCategories={this.hasCostCategoriesValue} />
    )
  }
}
